import { InternationalPhoneInput } from './InternationalPhoneInput';

export type { TypeInternationalPhoneInputProps } from './types';
export default InternationalPhoneInput;
